import { Settings } from "react-slick";

export const sliderSettings: Settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: undefined,
  nextArrow: undefined,
};
